import {
  GetSelfDocument,
  useFragment,
  UserMainFieldsFragmentDoc,
  type UserOverviewFragment,
  UserOverviewFragmentDoc,
} from "owfsa-graphql";
import { useQuery } from "@urql/vue";
import { defineStore } from "pinia";
import { computed, ref, type Ref } from "vue";
import { toast } from "vue-sonner";

export const useUserStore = defineStore("userStore", () => {
  const self: Ref<UserOverviewFragment | null> = ref(null);

  const getSelfQuery = useQuery({
    query: GetSelfDocument,
    pause: true,
  });

  const userExists = computed(() => {
    return !!self.value?.id;
  });

  const isBlocked = computed(() => self.value?.isDeleted || self.value?.isSuspended);

  const refetchUser = async () => {
    const result = await getSelfQuery.executeQuery({
      requestPolicy: "network-only",
    });
    if (!result.error?.value) {
      const userData = useFragment(UserMainFieldsFragmentDoc, result.data.value?.self);
      self.value = userData ? useFragment(UserOverviewFragmentDoc, userData) : null;
    } else {
      toast.error(`Error while fetching user: ${result.error.value.message}`);
    }
  };

  return {
    self,
    userExists,
    getSelfQuery,
    isBlocked,
    refetchUser,
  };
});
